import React from "react";
import styled from "styled-components";

import ModalBasic from "./ModalBasic.jsx";

const ModalGuestHandoffStatus = ({ notice, onClose, onRetry }) => {
  if (!notice) return null;

  return (
    <ModalBasic
      isOpen
      onClose={onClose}
      width={window.innerWidth > 430 ? "400px" : "312px"}
      height="fit-content"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
    >
      <ContentWrapper>
        <Header>{notice.title}</Header>
        <Content>{notice.description}</Content>
        <ButtonWrapper>
          {notice.retryable && (
            <Button type="button" onClick={onRetry}>
              다시 시도
            </Button>
          )}
          <Button type="button" $primary onClick={onClose}>
            확인
          </Button>
        </ButtonWrapper>
      </ContentWrapper>
    </ModalBasic>
  );
};

const ContentWrapper = styled.div`
  padding: 32px;

  @media (max-width: 430px) {
    padding: 24px;
  }
`;

const Header = styled.h2`
  margin: 0;
  color: #000;
  font-size: 18px;
  font-weight: 700;

  @media (max-width: 430px) {
    font-size: 16px;
  }
`;

const Content = styled.p`
  margin: 16px 0 24px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 15px;
  font-weight: 400;
  line-height: 25px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

const Button = styled.button`
  min-width: 88px;
  height: 40px;
  padding: 0 14px;
  border: 0;
  border-radius: 6px;
  background: ${({ $primary }) => ($primary ? "#000" : "#f2f2f2")};
  color: ${({ $primary }) => ($primary ? "#fff" : "#000")};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;

export default ModalGuestHandoffStatus;
